// The ONE scroller for the phone/tablet full-screen builders (KAN-763),
// mirroring Log Job's `scrollWrap` (flex 1, minHeight 0, overflowY auto,
// overscroll contained). Desktop does not use this: FullScreenTwoPane owns its
// own form-pane scroller.
import { foundation } from '../../../ui';
import { layoutStyles as L, LOGJOB_COLUMN_MAX_WIDTH } from '../../../pages/logJobLayoutStyles';

const sp = foundation.spacePx;

export const flowBodyScroller = {
  flex: 1,
  minHeight: 0,
  width: '100%',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  overscrollBehavior: 'contain',
};
const phoneInner = { padding: `${sp[3]} ${sp[4]}` };
const tabletInner = { ...L.column, maxWidth: `${LOGJOB_COLUMN_MAX_WIDTH}px`, ...L.columnPadTablet };

/** The inner padding/column wrapper for a phone or tablet scroller (shared with FullScreenStepPager). */
export function flowBodyInnerStyle(layout) {
  return layout === 'phone' ? phoneInner : tabletInner;
}

/**
 * @param {object} props
 * @param {'phone'|'tablet'|'desktop'} props.layout
 * @param {import('react').Ref<HTMLDivElement>} [props.scrollRef]
 * @param {string} [props.testId]
 */
export default function FullScreenFlowBody({ layout, scrollRef, children, testId = 'fullscreen-flow-body' }) {
  return (
    <div ref={scrollRef} style={flowBodyScroller} data-testid={testId} data-layout={layout}>
      <div style={flowBodyInnerStyle(layout)}>{children}</div>
    </div>
  );
}
